<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="vol-1-dedication">
<div class="text" id="vol-1-dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">For my eternal dragon</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001dedication.vue?5d37884e